import InscreenObserver from '@finn-no/inscreen-observer';

export const lazyLoad = (elements, callback, options = { once: true }) => {
    const observer = new InscreenObserver(callback, options);
    for (let i = 0, len = elements.length; i < len; i++) {
        if (elements[i] !== null && elements[i] !== undefined) {
            elements[i].innerHTML = '';
            observer.observe(elements[i]);
        }
    }
};
